// extracted by mini-css-extract-plugin
export var section = "xealProvides-module--section--ab148";